var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-93-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-92",
    transform: "translate(23.000000, 8.000000)",
    fill: "#FF6666"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 0 6 2 6 2 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 7 0 9 2 9 2 7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons-24-/-Outline-/-Core-UI-/-notifications_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.9999926e-8,
    y: -5.68434189e-14,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,20 C11.4477153,20 11,19.5522847 11,19 L9.00000005,19 C9.00000005,20.6568542 10.3431458,22 12,22 C13.6568543,22 15,20.6568542 15,19 L13,19 C13,19.5522847 12.5522848,20 12,20 Z M19,15 L19,12 C18.9991875,8.70549905 16.9788167,5.74837466 13.91,4.55 C13.9655218,4.3717655 13.9958159,4.1866352 14,4 C14,2.8954305 13.1045695,2 12,2 C10.8954306,2 10,2.8954305 10,4 C10.0041842,4.1866352 10.0344783,4.3717655 10.09,4.55 C7.02118345,5.74837466 5.00081255,8.70549905 5.00000005,12 L5.00000005,15 L3.00000005,15 L3.00000005,17 L21,17 L21,15 L19,15 Z M17,15 L7.00000005,15 L7.00000005,12 C7.00409758,9.53124028 8.51995282,7.31698053 10.82,6.42 L12,6 L13.18,6.47 C15.4631659,7.36025947 16.9754645,9.54952935 17,12 L17,15 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fill: "#48DAD0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.a0d7f8e06b26758359108d04078c5831.svg";
export { ForwardRef as ReactComponent };